import { PrivacyPolicy1Props } from "./props";

import styles from "./privacy-policy.module.scss";
import { handleFormatStyleString } from "@/components/package-components/utils";

export const PrivacyPolicy1 = (props: PrivacyPolicy1Props) => {
  const content =
    props.description?.value ??
    // @ts-ignore
    props.description.description ??
    props.description;
  return (
    <>
      {props && props.styles && props.styles.value && (
        <style>
          {handleFormatStyleString(props.styles.value as string, props.id)}
        </style>
      )}

      {typeof props.description != "undefined" && (
        <div className={`${styles.container} container-${props.id} !pt-20`}>
          <div
            className={`${styles.wrapper} wrapper-${props.id}`}
            dangerouslySetInnerHTML={{
              __html: String(content),
            }}
          />
        </div>
      )}
    </>
  );
};
